import { useSearchParams } from "react-router-dom";

export function useUtmSource(): string | null {
  const [qs] = useSearchParams();

  return qs.get("utm_source") || qs.get("homepage_utm_source");
}
